import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React, { PureComponent } from "react";
// Material imports
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import AppBar from "@material-ui/core/AppBar";
import { withStyles } from "@material-ui/core/styles";

var SlideIndicator = /*#__PURE__*/function (_PureComponent) {
  _inherits(SlideIndicator, _PureComponent);

  var _super = _createSuper(SlideIndicator);

  function SlideIndicator() {
    _classCallCheck(this, SlideIndicator);

    return _super.apply(this, arguments);
  }

  _createClass(SlideIndicator, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          onSlideChange = _this$props.onSlideChange,
          activeSlideIndex = _this$props.activeSlideIndex,
          slideCount = _this$props.slideCount;
      var tabs = [];

      for (var i = 0; i < slideCount; i++) {
        tabs.push( /*#__PURE__*/React.createElement(Tab, {
          key: i,
          id: "hiwDot-".concat(i + 1),
          classes: {
            root: classes.tabRoot
          },
          component: "div"
        }));
      }

      return /*#__PURE__*/React.createElement(AppBar, {
        position: "static",
        color: "default",
        classes: {
          root: classes.paperRoot
        },
        component: "div"
      }, /*#__PURE__*/React.createElement(Tabs, {
        value: activeSlideIndex,
        onChange: onSlideChange,
        classes: {
          root: classes.paperRoot,
          flexContainer: classes.tabFlexContainer,
          indicator: classes.activeIndicator
        }
      }, tabs));
    }
  }]);

  return SlideIndicator;
}(PureComponent);

var styles = function styles(theme) {
  return {
    paperRoot: {
      borderBottomLeftRadius: "12px",
      borderBottomRightRadius: "12px",
      backgroundColor: "white",
      minHeight: "0px",
      padding: "5px",
      boxShadow: "none"
    },
    tabRoot: {
      minWidth: 0,
      margin: 5,
      backgroundColor: theme.palette.primary.light,
      height: 12,
      width: 12,
      borderRadius: "50%",
      minHeight: 12,
      //for IE11,
      padding: 0
    },
    tabFlexContainer: {
      justifyContent: "center"
    },
    activeIndicator: {
      backgroundColor: theme.palette.primary.dark,
      height: "12px",
      width: "12px",
      borderRadius: "50%",
      marginBottom: "5px",
      padding: 0
    }
  };
};

export default withStyles(styles)(SlideIndicator);